import WidgetBase from '../widget.base';
import { mq } from '../../lib/util';
import { duration, mqMap } from '../../lib/const';
import Hammer, { each } from 'hammerjs';

export default class GraphicalCalloutGrid extends WidgetBase {
    static selector = '[data-ww-graphical-callout-grid]';
    flex = 4;
    cinemgraphs;
    activeSlideView;
    container;
    slides = [];
    nextBtn;
    prevBtn;
    currentIndex;
    slidesToRemove = [];
    originalLength;
    offsetAmount = 20;

    isAnimating = false;
    mobileBP = mqMap.sm;
    tabletBP = 979;
    constructor(el){
        super(el);
        if(!el){
            return false;
        }
       this.cinemgraphs = this.el.querySelectorAll('[data-cinemagraph]');

        this.slides = (this.el.querySelectorAll('[data-ww-graphical-callout-slide]'));
        this.slides[this.slides.length-1];
        this.originalLength = this.slides.length;

        setTimeout(() => {
            this.setPaddingTop();
            if(this.slides.length > 3){
                this.activeSlideView = this.el.querySelector('[data-ww-graphical-callout-grid-active-view]');
                this.activeSlideView.classList.add('is-carousel');
                this.el.classList.add('carousel');
                this.setUpSlides();
                window.addEventListener('resize', this.setUpSlides.bind(this));
            }
            this.loaded();
        }, 500)
    }

    setPaddingTop() {
        each(this.slides, (slide) => {
            const heading = slide.querySelector('.ww-graphical-cg__image__content');
            const summary = slide.querySelector('.ww-graphical-cg__fly-out__summary');
            const height = heading.offsetHeight;
            summary.style.paddingTop = `${height + 10}px`;
        })
    }

    setUpSlides(){
        this.container = this.el.querySelector('[data-ww-graphical-callout-grid-container]');
        this.nextBtn = this.el.querySelector('[data-ww-graphical-callout-grid-next]');
        this.prevBtn = this.el.querySelector('[data-ww-graphical-callout-grid-prev]');
        this.nextBtn.addEventListener('click', this.next);
        this.prevBtn.addEventListener('click', this.prev);

        const Swipe = new Hammer.Swipe();
        // Create a manager to manager the element
        var manager = new Hammer.Manager(this.container.querySelector('.ww-graphical-cg__wrapper'));
        manager.add(Swipe);

        if(this.slides.length > 3) {
            manager.on('swipe', (e) => {
                var direction = e.offsetDirection;

                if (direction === 2) {
                    this.next();
                }else if(direction === 4) {
                    this.prev();
                }
            });
        }

        each(this.slides, (slide, index) => {
            switch (index % 3) {
                case 0:
                    slide.classList.add('bg-1');
                    break;
                case 1:
                    slide.classList.add('bg-2');
                    break;
                case 2:
                    slide.classList.add('bg-3');
                    break;
                default:
                    break;
            }

        })

        //adjust the structure so that one card is surrounded by two inactive for mobile
        //for desktop, three active are surrounded by one inactive on each side
        // if (this.isMobile()){
        //     this.flex = 3;
        //     this.currentIndex = 0;
        // } else{
        //     if(this.slides.length === 4){
        //         const lastSlide = this.slides[this.slides.length -1];
        //         const clone = lastSlide.cloneNode(true);
        //         this.activeSlideView.insertBefore(clone, this.slides[0]);
        //         this.slides = (this.el.querySelectorAll('[data-ww-graphical-callout-slide]'));
        //     }
        //     this.flex = 4;
        //     this.currentIndex = 1;
        // }
        this.currentIndex = 0;


        for(var i = this.slides.length -1;i >= 0; i--) {
            const slide = this.slides[i];
            const clone = slide.cloneNode(true);
            this.activeSlideView.prepend(clone);

        }
        each(this.slides, (slide) => {
            const clone = slide.cloneNode(true);

            this.activeSlideView.append(clone);
        })

        this.container.style.width = '100%';

        // if (this.isMobile()) {
        //     let newFlex = 100 / this.flex;
        //     for(let i = 0; i < this.slides.length; i++){
        //         let slide = this.slides[i];
        //         slide.style.flex = '1 0 ' + newFlex + '%';
        //         slide.style.width = newFlex + '%';
        //         slide.style.maxWidth = newFlex + '%';
        //     }
        // }

        // this.activeSlideView.style.justifyContent = "normal";
        // let offset = (window.innerWidth > mqMap.lg && window.innerWidth < 1600) ? 4 : 2;
        // if(this.isMobile()) {
        //     offset = 1;
        // }
        // let initialTranslate = this.activeSlideView.offsetWidth/(this.flex*offset);
        let initialTranslate = Array.from(this.slides).reduce((previousVal, slide) => {
            return previousVal + slide.offsetWidth
        }, 0);
        this.initialTranslate = initialTranslate;
        this.translateX = initialTranslate;
        this.activeSlideView.style.transform = "translateX("+(-1 *initialTranslate)+"px)";

        // //if there are 4 slides, just put the view at the beginning
        // if(this.slides.length === 4 && !this.isMobile()){
        //     this.transformSlideContainer(this.currentIndex);
        // } else {
        //     this.transformSlideContainer(this.currentIndex+1);
        // }

        this.toggleArrows(this.currentIndex);

    }

    prev = () =>{
        if(this.isAnimating){
            return;
        } else{
            this.isAnimating = true;
        }
        const newIndex = this.currentIndex-1;
        this.translateX -= this.slides[0].offsetWidth;
        this.activeSlideView.style.transform = "translateX("+(-1 *this.translateX)+"px)";
        // this.moveLastSlideToFront();
        setTimeout(() => {
            if (newIndex <= -this.originalLength) {
                this.activeSlideView.classList.add("no-transition");
                this.activeSlideView.style.transform = "translateX("+(-1 *this.initialTranslate)+"px)";
                this.currentIndex = 0;
                this.translateX = this.initialTranslate;
                setTimeout(() => {
                    this.activeSlideView.classList.remove('no-transition');
                    this.isAnimating = false;
                }, 50);
            }
            else {
                this.currentIndex = newIndex;
                this.isAnimating = false;
            }

        }, duration+50)


    }

    next = () =>{
        if(this.isAnimating){
            return;
        } else{
            this.isAnimating = true;
        }
        const newIndex = this.currentIndex+1;
        this.translateX += this.slides[0].offsetWidth;
        this.activeSlideView.style.transform = "translateX("+(-1 *this.translateX)+"px)";
        // this.moveFirstSlideToLast();

        setTimeout(() => {
            if (newIndex >= this.originalLength) {
                this.activeSlideView.classList.add("no-transition");
                this.activeSlideView.style.transform = "translateX("+(-1 *this.initialTranslate)+"px)";
                this.currentIndex = 0;
                this.translateX = this.initialTranslate;
                setTimeout(() => {
                    this.activeSlideView.classList.remove('no-transition');
                    this.isAnimating = false;
                }, 50);
            }
            else {
                this.currentIndex = newIndex;
                this.isAnimating = false;
            }
            // for(let i = 0; i < this.slidesToRemove.length; i++){
            //     this.slidesToRemove[i].remove();
            // }

            //  this.adjustSliderViewForOffset('right', true);
            //   this.slides = this.el.querySelectorAll('[data-ww-graphical-callout-slide]');
        }, duration+50)
    }

    toggleArrows(idx){
        if(this.slides.length > 3){
            this.nextBtn.classList.remove('hidden');
            this.prevBtn.classList.remove('hidden');
        }
    }

    transformSlideContainer(idx, accountForOffset = false){
        let translateX = this.activeSlideView.offsetWidth / this.flex;
        let currentTransform = this.parseTransformX(this.activeSlideView.style.transform);
        //moving to the right
        if(idx > this.currentIndex){
            translateX*= -1;
            let newTranslate = (translateX) + currentTransform;
            if(accountForOffset && !this.isMobile()){
                newTranslate -= this.offsetAmount;
            }
            this.activeSlideView.style.transform = "translateX("+newTranslate+"px)";
        //moving to the left
        } else if(idx < this.currentIndex){

            let newTranslate = translateX + currentTransform;
            if(Math.abs(translateX) == Math.abs(currentTransform)){
                newTranslate = 0;
            }

            this.activeSlideView.style.transform = "translateX("+newTranslate+"px)";
        }

        this.currentIndex = idx;
    }

    addRemoveActiveClasses(idx){
        let isMobile = this.isMobile();
        for(let i = 0; i < this.slides.length; i++){
            let slide = this.slides[i];
            slide.classList.add('inactive');

            let mod = idx >= this.originalLength ? Math.abs(idx) % this.originalLength : idx;

            if(!isMobile && (i === 1 || i === 2 || i === 3)){
                slide.classList.remove('inactive');
            }
            else if(isMobile && (i === 1)){
                slide.classList.remove('inactive');
            }
        }
    }

    adjustSliderViewForOffset(rightOrLeft, accountForOffset = false){
        let translateX = this.activeSlideView.offsetWidth / this.flex;
        const multiplier = rightOrLeft === 'left' ? -1 : 1;
        translateX *= multiplier;
        const currentTransform = this.parseTransformX(this.activeSlideView.style.transform);
        let newTranslate = translateX + currentTransform ;
        if(accountForOffset && !this.isMobile()){
            newTranslate += this.offsetAmount;
        }
        this.activeSlideView.classList.add("no-transition");
        this.activeSlideView.style.transform = "translateX("+newTranslate+"px)";

        setTimeout(() => this.activeSlideView.classList.remove("no-transition"), 10);
    }

    moveLastSlideToFront(slideToMoveIndex){
        //if there are four slides, take the length - 2, this will prevent duplicate slides
        const idx = (this.originalLength === 4 && !this.isMobile())? this.slides.length - 2 : this.slides.length - 1;
        const lastSlide = this.slides[idx];
        const clone = lastSlide.cloneNode(true);

        this.removeAnimationClasses(clone);

        this.activeSlideView.insertBefore(clone, this.slides[0]);
        this.adjustSliderViewForOffset('left');
        this.slides = (this.el.querySelectorAll('[data-ww-graphical-callout-slide]'));
        if(this.originalLength === 4 && !this.isMobile()){
            this.slidesToRemove.push(this.slides[this.slides.length -1]);
        } else{
            this.slidesToRemove.push(lastSlide);

        }
    }

    moveFirstSlideToLast(){
        const idx = (this.originalLength === 4 && !this.isMobile()) ? 1 : 0;
        const firstSlide = this.slides[idx];
        const clone = firstSlide.cloneNode(true);

        this.removeAnimationClasses(clone);

        this.activeSlideView.insertBefore(clone, null);
        this.slides = (this.el.querySelectorAll('[data-ww-graphical-callout-slide]'));
        this.slidesToRemove.push(this.slides[0]);
    }

    parseTransformX(transform) {
        if(!transform) {
            return 0;
        }
        return parseInt(transform.split('(')[1].split(',')[0])
    }

    isMobile(){
        //target mobile devices
        // return mq(this.cardBP);
        let browserWidth = window.innerWidth;
        return (browserWidth < 768);
    }

    isTablet() {
        let browserWidth = window.innerWidth;
        // return (browserWidth >= this.tabletBP && < )
    }

    removeAnimationClasses(node){
        let header = node.querySelector('.animate-down');
        header.style.transform = "translateY(0px)";
         header.classList.add('no-animate');
         let gradBox = node.querySelector('.fade-in');
         gradBox.classList.add('no-animate');
    }
}